export default __webpack_public_path__ + "static/media/Leggings of the Farseeker.b6800640.jpg";